"use client"
import { env } from "@/lib/env"
import posthog from "posthog-js"
import { PostHogProvider } from "posthog-js/react"
import { useEffect } from "react"

export function PosthogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (env.NEXT_PUBLIC_APP_ENV !== "production") return

    posthog.init("phc_I4q7e0SeGx849mQU8EyDa0VmceKSlTQJXQ7nmiufzpo", {
      api_host: "https://eu.posthog.com",
      // api_host: "/ingest",
      capture_pageview: false, // Disable automatic pageview capture, as we capture manually
      capture_pageleave: true,
    })
  }, [])
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
